import { configureStore } from "@reduxjs/toolkit";
import authReducer from './reducers/authSlice';
import roiReducer from './reducers/roiSlice';
import modalReducer from './reducers/modalSlice';
import adReducer from './reducers/adSlice';
import adjustmentReducerForGoogle from './reducers/ajustmentSliceForGoogle';
import adjustmentReducerForFB from './reducers/adjustmentSliceForFB';
import adjustmentReducerForSnap from './reducers/adjustmentSliceForSnap';
import adjustRoiReducer from './reducers/adjustRoiSlice';

export default configureStore({
    reducer: {
        authReducer,
        roiReducer,
        modalReducer,
        adReducer,
        adjustRoiReducer,
        adjustmentReducerForFB,
        adjustmentReducerForSnap,
        adjustmentReducerForGoogle
    }
});